import { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { client } from '../lib/sanity'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import Button from '../components/ui/Button'
import { expandEvents } from '../lib/recurrence'

const localizer = momentLocalizer(moment)

const defaultRange = () => ({
    start: moment().startOf('month').subtract(1, 'week').toDate(),
    end: moment().endOf('month').add(1, 'week').toDate(),
})

export default function PublicCalendar() {
    const [rawDocs, setRawDocs] = useState([])
    const [visibleRange, setVisibleRange] = useState(defaultRange)
    const navigate = useNavigate()

    useEffect(() => {
        const fetchEvents = async () => {
            const data = await client.fetch(`*[_type == "calendarEvent"]`)
            setRawDocs(data)
        }
        fetchEvents()
    }, [])

    const events = useMemo(
        () => expandEvents(rawDocs, visibleRange.start, visibleRange.end).map(e => ({
            title: 'Busy',
            start: e.start,
            end: e.end,
            allDay: e.allDay,
        })),
        [rawDocs, visibleRange]
    )

    const handleRangeChange = (range) => {
        const [start, end] = Array.isArray(range) ? [range[0], range[range.length - 1]] : [range.start, range.end]
        setVisibleRange({
            start: moment(start).subtract(1, 'week').toDate(),
            end: moment(end).add(1, 'week').toDate(),
        })
    }

    return (
        <div className="min-h-screen bg-white dark:bg-zinc-950">
            <div className="max-w-7xl mx-auto p-6 md:p-10">
                <div className="mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                    <div>
                        <h2 className="text-4xl font-serif font-bold text-black dark:text-white">Availability</h2>
                        <p className="mt-2 text-zinc-600 dark:text-zinc-300">
                            See when I'm free, then reach out to lock in a time.
                        </p>
                    </div>
                    <Button as={Link} to="/contact">Request a time →</Button>
                </div>
                <div className="border-2 border-black dark:border-white bg-white dark:bg-zinc-950 p-2">
                    <Calendar
                        className="rbc-custom"
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        onRangeChange={handleRangeChange}
                        views={["month", "week", "day"]}
                        style={{ height: 600 }}
                    />
                </div>
                <div className="mt-4 text-right">
                    <button
                        onClick={() => navigate('/login', { state: { from: '/admin/calendar' } })}
                        className="text-xs font-mono text-zinc-400 hover:text-accent dark:text-zinc-600 dark:hover:text-accent transition-colors"
                    >
                        Admin login
                    </button>
                </div>
            </div>
        </div>
    )
}
